/** Maximum width for mobile devices (≤767px) */
export const MOBILE_MAX_WIDTH = 767;

/** Minimum width for tablet devices (768px) */
export const TABLET_MIN_WIDTH = 768;

/** Maximum width for tablet devices (≤1366px) */
export const TABLET_MAX_WIDTH = 1366;

/** Minimum width for desktop devices (1367px) */
export const DESKTOP_MIN_WIDTH = 1367;

/** iPad landscape width (1024px) */
export const IPAD_LANDSCAPE_WIDTH = 1024;

/** iPad Pro 11" landscape width (1194px) */
export const IPAD_PRO_11_LANDSCAPE_WIDTH = 1194;

/** iPad Pro 12.9" landscape width (1366px) */
export const IPAD_PRO_129_LANDSCAPE_WIDTH = 1366;

/**
 * Check if the current viewport is mobile or below (≤767px)
 * Safe for SSR - returns false if window is not available
 */
export function isMobileOrBelow(): boolean {
  return globalThis.window !== undefined && globalThis.window.innerWidth <= MOBILE_MAX_WIDTH;
}

/**
 * Check if the current viewport is tablet only (768px - 1366px)
 * Safe for SSR - returns false if window is not available
 */
export function isTabletOnly(): boolean {
  return (
    globalThis.window !== undefined &&
    globalThis.window.innerWidth >= TABLET_MIN_WIDTH &&
    globalThis.window.innerWidth <= TABLET_MAX_WIDTH
  );
}

/**
 * Check if the current viewport is tablet or below (≤1366px)
 * Safe for SSR - returns false if window is not available
 * 
 * Use this for hiding columns or adjusting layouts for iPad and smaller devices
 */
export function isTabletOrBelow(): boolean {
  return globalThis.window !== undefined && globalThis.window.innerWidth <= TABLET_MAX_WIDTH;
}

/**
 * Check if the current viewport is desktop (>1366px)
 * Safe for SSR - returns false if window is not available
 */
export function isDesktop(): boolean {
  return globalThis.window !== undefined && globalThis.window.innerWidth > TABLET_MAX_WIDTH;
}

/**
 * Check if the current viewport matches a custom breakpoint
 * Safe for SSR - returns false if window is not available
 * 
 * @param minWidth - Minimum width (inclusive)
 * @param maxWidth - Maximum width (inclusive), optional
 */
export function matchesBreakpoint(minWidth: number, maxWidth?: number): boolean {
  if (globalThis.window === undefined) {
    return false;
  }

  const width = globalThis.window.innerWidth;
  const meetsMin = width >= minWidth;
  const meetsMax = maxWidth === undefined || width <= maxWidth;

  return meetsMin && meetsMax;
}
